// d.io's colours for a post (dio-marketing src/styles/tokens.css, in sRGB)
export const WHATS_NEW_COLORS = {
  text1: "#1d1f26",
  text2: "#595a62",
  text3: "#6c6e76",
  line: "#e1e1e1",
  link: "#d3006c",
}

// The panel's content column
export const WHATS_NEW_IMAGE_SIZES = "416px"
